import { styled } from "styled-components";

import { getColorByScore } from "@/utils";

export const baseReMintStyles = {
  Container: styled.div`
    display: flex;
    width: 100%;
    padding: 0.75rem;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;

    border-radius: 1rem;
    background: ${({ theme }) => theme.colors.surfaceReMint};
  `,

  ScoreAmount: styled.div<{ $score: number }>`
    gap: 0.25rem;
    display: flex;
    align-items: flex-end;

    & > span {
      line-height: 140%;
      color: ${({ theme }) => theme.colors.black};
      font-family: ${({ theme }) => theme.fonts.grotesk};

      &:first-of-type {
        color: ${({ $score }) => getColorByScore($score)};
        -webkit-text-stroke: 1px ${({ theme }) => theme.colors.black};
        text-shadow: 1px 1px 0px ${({ theme }) => theme.colors.black};

        font-weight: 900;
        font-size: 1.25rem;
      }

      &:last-of-type {
        opacity: 0.5;
        font-size: 0.875rem;
        font-weight: 600;
      }
    }
  `,

  Text: styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    & > span {
      color: ${({ theme }) => theme.colors.black};
      font-size: 0.875rem;
      font-weight: 600;
      line-height: 140%;
    }
  `,
};

export const reMintWithExpiryStyles = {
  Container: styled.div<{ $isExpired?: boolean }>`
    display: flex;
    width: 100%;
    padding: 0.75rem;
    justify-content: space-between;
    align-items: center;
    gap: 0.5rem;

    border-radius: 1rem;
    background: ${({ theme }) => theme.colors.surfaceReMint};
    border: 1px solid ${({ theme, $isExpired }) => ($isExpired ? theme.colors.warningRed : theme.colors.warning)};

    & > svg {
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ theme, $isExpired }) => ($isExpired ? theme.colors.warningRed : theme.colors.warning)};
    }
  `,

  Text: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    color: ${({ theme }) => theme.colors.black};
    font-size: 0.875rem;
    font-weight: 600;
    line-height: 140%;
  `,
};

export const reMintWithExpiryAndUpdateStyles = {
  Container: styled.div<{ $isExpired?: boolean }>`
    display: flex;
    flex-direction: column;
    width: 100%;
    padding: 0.75rem;
    justify-content: space-between;
    gap: 0.75rem;

    border-radius: 1rem;
    background: ${({ theme }) => theme.colors.surfaceReMint};
    border: 1px solid ${({ theme, $isExpired }) => ($isExpired ? theme.colors.warningRed : theme.colors.warning)};

    svg {
      align-self: center;
      width: 1.25rem;
      height: 1.25rem;
      color: ${({ theme, $isExpired }) => ($isExpired ? theme.colors.warningRed : theme.colors.warning)};
    }
  `,

  Header: styled.div`
    display: flex;
    gap: 0.5rem;
  `,

  Text: styled.div`
    flex: 1;
    display: flex;
    flex-direction: column;
    height: 100%;
    justify-content: space-between;
    & > span {
      &:first-of-type {
        color: ${({ theme }) => theme.colors.black};
        font-size: 0.875rem;
        font-weight: 600;
        line-height: 140%;
      }
      &:last-of-type {
        color: ${({ theme }) => theme.colors.secondaryText};
        font-size: 0.75rem;
        font-weight: 600;
        line-height: 140%;
      }
    }
  `,
};
